<template>
  <Swiper class="app-hero-image-multiple" :options="swiperOptions">
    <SwiperSlide v-for="image in images" :key="image.id">
      <img class="image" :alt="image.media.alt" :src="image.media.url" fetchpriority="high" />
    </SwiperSlide>
  </Swiper>
</template>

<script>
export default {
  name: 'AppHeroImageMultiple',
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  computed: {
    swiperOptions() {
      return {
        autoHeight: true,
        preloadImages: true,
        speed: 1000,
        watchOverflow: true,

        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 1.2,
            spaceBetween: 24,
          },
          992: {
            slidesPerView: this.images.length > 2 ? 2.2 : 2,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: this.images.length,
            spaceBetween: 24,
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-hero-image-multiple {
  .swiper-slide {
    width: calc(100% / 1.2);

    @media (min-width: vars.$desktop-lg-992-break-point) {
      width: calc(100% / 2.2);
    }

    @media (min-width: vars.$desktop-xl-1200-break-point) {
      width: calc(100% / 3);
    }
  }

  .image {
    width: 100%;
    height: 100%;
    min-height: 200px;
    max-height: 400px;
    object-fit: cover;
    aspect-ratio: 624 / 400;
  }
}
</style>
